import { FC } from 'react';
import { ArrowLongRightIcon } from '@heroicons/react/24/outline';
import Typography from 'components/commercetools-ui/atoms/typography';
import useImageSizes from 'helpers/hooks/useImageSizes';
import { ContentSliderSlideProps } from './types';
import Link from '../../atoms/link';
import Image from 'frontastic/lib/image';
import usePreloadImages from 'helpers/hooks/usePreloadImages';
import { NationalBook, NationalSemibold, Tiempos } from 'fonts';

const ContentSliderSlide: FC<ContentSliderSlideProps> = ({ image, card_title, ctas, summary, card_description }) => {
  const tileImageSizes = useImageSizes({ md: 1, lg: 0.33, defaultSize: 0.33 });

  const height = 'flex gap-1.5 flex-col';

  const description = card_description
    ? `mt-12 font-normal leading-6 text-wrap text-16 xl:text-14 2xl:text-16 text-[#333] min-h-[50px] ${height} ${NationalBook.className}`
    : '';

  const link = `w-full overflow-hidden relative ${card_description ? 'h-auto' : 'h-auto'} h-auto hover:bg-[#D9D9D9]`;
  usePreloadImages([image?.url]);

  return (
    <Link link={ctas?.[0]?.button?.href} className={`${link} group`}>
      {image && (
        <div className="relative">
          <div className="absolute z-10 bg-black opacity-20"></div>
          <Image
              priority
              loading='eager'
              src={encodeURI(image?.url)}
              alt={image?.description}
              sizes="100vw"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '650px',
                objectFit: 'cover',
              }}
              width={500}
              height={300}
              />
        </div>
      )}
      
      {/* Remove "overflow-hidden" from css because we want to show full name */}
      <div className="px-[20px] pb-[10px]">
        {card_title && (
          <Typography
            as="h4"
            className={`mt-12 max-w-[90%] break-words text-22 font-medium leading-[30px] 
            text-[#090909] md:text-18 lg:text-20 xl:text-18 2xl:text-22 
            ${NationalSemibold.className}`}
          >
            {card_title}
          </Typography>
        )}
        {card_description && (
          <Typography as="p" className={`${description}  ${NationalBook.className}`}>
            {card_description}
          </Typography>
        )}
        {ctas?.length > 0 && (
          <div className={`${height} group-hover:translate-x-14`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="green">
              <path
                d="M18 9L25 16M25 16L18 23M25 16L7 16"
                stroke="#666666"
                className="hidden group-hover:stroke-[#090909] md:block"
                strokeWidth="2"
                strokeLinecap="square"
              />
            </svg>
          </div>
        )}
      </div>
    </Link>
  );
};

export default ContentSliderSlide;
